export const colors = {
    'action-primary': '#65C41C',
    'action-primary-hovered': '#4DA50D',
    'action-primary-pressed': '#3A7B0F',
    'action-primary-subdued': '#F3FEE7',
    'action-primary-subdued-hovered': '#E4FBCB',
    'action-primary-subdued-pressed': '#CDEAAE',
    'action-primary-disabled': '#F3F4F7',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#F9FAFB',
    'action-neutral-pressed': '#F3F4F7',
    'action-neutral-subdued': '#F3F4F7',
    'action-neutral-subdued-hovered': '#EAECF0',
    'action-neutral-subdued-pressed': '#D0D5DD',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#F04438',
    'action-destructive-hovered': '#D92D20',
    'action-destructive-pressed': '#B42318',
    'action-destructive-subdued': '#FEF3F1',
    'action-destructive-subdued-hovered': '#FEE4E2',
    'action-destructive-subdued-pressed': '#FECDCA',
    'action-destructive-disabled': '#F3F4F7',
    background: '#F3F4F7',
    'background-hovered': '#EAECF0',
    'background-pressed': '#D0D5DD',
    'background-selected': '#D0D5DD',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#98A2B3',
    content: '#101828',
    'content-subdued': '#475466',
    'content-muted': '#667085',
    'content-hovered': '#101828',
    'content-pressed': '#475466',
    'content-disabled': '#98A2B3',
    'content-on-positive': '#027A48',
    'content-on-attention': '#B54708',
    'content-on-highlight': '#173FB6',
    'content-on-negative': '#B42318',
    'content-on-negative-hovered': '#912018',
    'content-on-negative-pressed': '#7A271A',
    'content-primary': '#336312',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#FCFCFD',
    'content-on-destructive': '#FFFFFF',
    'content-on-background': '#101828',
    'content-on-background-subdued': '#475466',
    'content-on-background-hovered': '#101828',
    'content-on-background-pressed': '#101828',
    'content-on-background-disabled': '#98A2B3',
    'decorative-surface-1': '#FFC96B',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#4f46e5',
    'decorative-content-5': '#FFFFFF',
    interactive: '#1B63F5',
    'interactive-hovered': '#144EE1',
    'interactive-pressed': '#173FB6',
    'interactive-disabled': '#F9FAFB',
    'interactive-destructive': '#F04438',
    'interactive-destructive-hovered': '#D92D20',
    'interactive-destructive-pressed': '#B42318',
    topbar: '#FFFFFF',
    'topbar-subdued': '#F9FAFB',
    'content-on-topbar': '#101828',
    'line-on-topbar': '#D0D5DD',
    'line-on-topbar-pressed': '#667085',
    line: '#D0D5DD',
    'line-subdued': '#EAECF0',
    'line-hovered': '#98A2B3',
    'line-pressed': '#667085',
    'line-disabled': '#EAECF0',
    'line-transparent': '#0000001a',
    'line-positive': '#039855',
    'line-positive-subdued': '#6DE9A6',
    'line-highlight': '#1B63F5',
    'line-highlight-subdued': '#8EC7FF',
    'line-negative': '#D92D20',
    'line-negative-subdued': '#FDA29B',
    'line-negative-disabled': '#FECDCA',
    'line-attention': '#DD6903',
    'line-attention-subdued': '#FEC94D',
    focused: '#4DA50D',
    skeleton: '#F3F4F7',
    surface: '#FFFFFF',
    'surface-subdued': '#F9FAFB',
    'surface-muted': '#F3F4F7',
    'surface-hovered': '#F3F4F7',
    'surface-pressed': '#EAECF0',
    'surface-disabled': '#F9FAFB',
    'surface-interactive': '#F5FAFF',
    'surface-interactive-hovered': '#EEF6FF',
    'surface-interactive-pressed': '#D9EBFF',
    'surface-attention': '#FEF0C7',
    'surface-attention-subdued': '#FFFCF5',
    'surface-negative': '#FEE4E2',
    'surface-negative-subdued': '#FFFBFA',
    'surface-negative-subdued-hovered': '#FEF3F1',
    'surface-negative-subdued-pressed': '#FEE4E2',
    'surface-positive': '#D1FADF',
    'surface-positive-subdued': '#F6FEF9',
    'surface-highlight': '#D9EBFF',
    'surface-highlight-subdued': '#F5FAFF',
    'surface-highlight-subdued-hovered': '#EEF6FF',
    'surface-highlight-subdued-pressed': '#D9EBFF',
    'surface-inverse': '#101828',
};
//# sourceMappingURL=colors.light.js.map